import {CommonModule} from '@angular/common';
import {Component, inject, OnInit} from '@angular/core';
import {MatButtonModule} from '@angular/material/button';
import {MatDialogModule, MatDialogRef} from '@angular/material/dialog';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {TranslateModule} from '@ngx-translate/core';
import {ActivitiesSearchEngineModule} from '@modules/activities/core/activities-search-engine';
import {
    SearchFilterSelection,
    SearchFilterValue,
} from 'shared/search-engine';
import {DataEntity} from 'octopus-connect';
import {MathiaSearchDataService} from '../mathia-search-data.service';
import {MathiaLessonsSearchFilterComponent} from '../mathia-lessons-search-filter/mathia-lessons-search-filter.component';

@Component({
    selector: 'app-mathia-activity-search-dialog',
    standalone: true,
    imports: [
        CommonModule,
        MatButtonModule,
        MatDialogModule,
        MatProgressSpinnerModule,
        ActivitiesSearchEngineModule,
        MathiaLessonsSearchFilterComponent,
        TranslateModule,
    ],
    templateUrl: './mathia-activity-search-dialog.component.html',
})
export class MathiaActivitySearchDialogComponent implements OnInit {
    private readonly dialogRef = inject(MatDialogRef<MathiaActivitySearchDialogComponent>);
    private readonly searchData = inject(MathiaSearchDataService);

    public selection: SearchFilterSelection<SearchFilterValue> = {};
    public activities: DataEntity[] = [];
    public isLoading = true;
    private selectedActivityIds = new Set<string | number>();
    private searchVersion = 0;

    public ngOnInit(): void {
        this.search(this.selection);
    }

    public onSelectionChange(selection: SearchFilterSelection<SearchFilterValue>): void {
        this.selection = selection;
        this.search(selection);
    }

    public toggleActivity(id: string | number): void {
        if (this.selectedActivityIds.has(id)) {
            this.selectedActivityIds.delete(id);
        } else {
            this.selectedActivityIds.add(id);
        }
    }

    public isSelected(id: string | number): boolean {
        return this.selectedActivityIds.has(id);
    }

    public get selectedActivityCount(): number {
        return this.selectedActivityIds.size;
    }

    public clearSelection(): void {
        this.selectedActivityIds.clear();
    }

    public close(): void {
        this.dialogRef.close([...this.selectedActivityIds]);
    }

    private search(selection: SearchFilterSelection<SearchFilterValue>): void {
        this.isLoading = true;
        const searchVersion = ++this.searchVersion;
        this.searchData.searchActivities(selection).subscribe({
            next: activities => {
                if (searchVersion !== this.searchVersion) {
                    return;
                }
                this.activities = activities;
                this.isLoading = false;
            },
            error: () => {
                if (searchVersion !== this.searchVersion) {
                    return;
                }
                this.activities = [];
                this.isLoading = false;
            },
        });
    }
}
